import request from '@/utils/request'

// 列表
export function getCollectionList(query) {
  return request({
    url: '/proposal/page',
    method: 'get',
    params: query
  })
}
// 意见处理
export function handelOpinion(query) {
  return request({
    url: '/proposal',
    method: 'put',
    data: query
  })
}
// 意见反馈
export function feedbackOpinion(query) {
  return request({
    url: '/proposal',
    method: 'post',
    data: query
  })
}
// 意见处理详情
export function opinionDetaile(id) {
  return request({
    url: '/proposal/' + id,
    method: 'get',
  })
}
